import { render } from "./BiographyView.vue?vue&type=template&id=2b136c68&scoped=true"
import script from "./BiographyView.vue?vue&type=script&lang=js"
export * from "./BiographyView.vue?vue&type=script&lang=js"

import "./BiographyView.vue?vue&type=style&index=0&id=2b136c68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b136c68"]])

export default __exports__